module.exports = __webpack_public_path__ + "static/media/gallery15.75f4e940.png";